export default __webpack_public_path__ + "static/media/i360-logo-512.b8518f62.png";